document.addEventListener("DOMContentLoaded", function () {
    console.log("スクリプトが読み込まれました"); // 確認用ログ

    setTimeout(function () {
        console.log("2秒後に要素を取得開始"); // 遅延実行の確認用ログ

        document.querySelectorAll(".socialplus-associate-banner-bubble-close").forEach(function (button) {
            console.log("ボタンが見つかりました:", button); // 確認用ログ

            button.addEventListener("click", function () {
                console.log("ボタンがクリックされました"); // クリック検知ログ

                const banner = document.querySelector(".socialplus-associate-id-banner-wrapper");
                if (banner) {
                    console.log("バナーが見つかりました。非表示にします。"); // 確認用ログ
                    banner.style.display = "none";
                } else {
                    console.log("バナーが見つかりませんでした。"); // 確認用ログ
                }
            });
        });
    }, 2000); // 2秒後に実行
});
